import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';

interface JournalPromptProps {
    promptText?: string | null;
}

export const JournalPrompt: FC<JournalPromptProps> = ({ promptText }) => {
    if (!promptText) return null;

    return (
        <Box sx={{ marginBottom: '16px', borderRadius: '12px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
            <Box sx={{ borderRadius: 'inherit', padding: '16px', ...liquidGlassSurfaceFillSx }}>
                <Text style={{ fontSize: '13px', color: 'var(--tg-theme-hint-color)' }}>
                    {promptText}
                </Text>
            </Box>
        </Box>
    );
};
